import { ApiService, ApiServiceInterface } from "../../../../../core";
import { FiltersMoreParts, MorePartsDataResponse, MorePartsPageController } from "../../core";

export class MorePartsPageControllerImpl implements MorePartsPageController {
    private api: ApiServiceInterface;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }
    
    async onLoad(): Promise<MorePartsDataResponse> {
        try {
            const response = await this.api.get('/more-parts/1');
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }
    
    async applyFilters(filters: FiltersMoreParts, page: number = 1): Promise<MorePartsDataResponse> {
        try {
            const response = await this.api.post(`/more-parts/${page}`, filters);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

}